import React, { useEffect, useState } from "react";
import { DataGrid } from '@mui/x-data-grid';
import { Card } from "reactstrap";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useParams } from "react-router-dom";
import { deleteDocument, documentList, getDownloadableLink } from "../../api/casp/document";
import dayjs from "dayjs";
import { Action, DefaultPerPageValue, PerPage } from "../../constants/Common";
import { Modules } from "../../constants/Module";
import DownloadIcon from '@mui/icons-material/Download';
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
import FilePreviewModal from "../casp/common/FilePreviewModal";
import { hasModulePermission } from "../../helpers/permission";
import { withTranslation } from "react-i18next";
import UserProfile from "../casp/common/userProfile";
import { PaginationComponent } from "../casp/common/PaginationComponent";
import { getUrl } from "../../helpers/file_helper";

const ProjectInfoTab = ({ disabled, t, refresh }) => {
  const { project } = useParams();
  const [page, setPage] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DefaultPerPageValue);
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [mounted, setMounted] = useState(false);
  const [triggerElement, setTriggerElement] = useState(+new Date())
  const [documentId, setDocumentId] = useState();
  const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false)
  const [modal, setModal] = useState(false);
  const [filePath, setFilePath] = useState('');
  const [fileName, setFileName] = useState('');
  const [paginatedObject, setPaginatedObject] = useState();
  const hasDeletePermissionForProjectCoreDocument = hasModulePermission(Modules.PROJECT_CORE_DOCUMENT, Action.DELETE)
  const columns = [
    { field: 'id', headerName: t('ID'), width: 114 },
    {
      field: 'fileName',
      headerName: t('File Name'),
      width: 400,
      editable: false,
    },
    {
      field: 'uploadDate',
      headerName: t('Upload Date'),
      width: 181,
      editable: false,
    },
    {
      field: 'uploadBy',
      headerName: t('Upload By'),
      width: 272,
      editable: false,
      renderCell: (params) => (
        <div
          className="MilestoneSubmissionIcon"
          style={{ display: "flex", alignItems: "center" }}
        >

          {/* <img
              src={DefaultImage}
              alt={params.row.pmName}
              style={{
                width: "24px",
                height: "24px",
                borderRadius: "50%",
                marginRight: "5px",
              }}
            /> */}
          <UserProfile user={params.row.user}
            profileStyle={{
              width: "30px",
              height: "30px",
              fontSize: '17px'
            }}
          />
          <div className="MuiDataGrid-cellContent mx-2">
            {t(params.row.uploadBy)}
          </div>
        </div>
      ),
    },
    {
      field: 'action',
      headerName: t('Actions'),
      sortable: false,
      width: 120,
      filterable: false,
      hideable: false,
      renderCell: (params) => (
        <div
          className="proSubmissionActions newActionIcons"
          style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
        >
          {/* previous code  */}

          {/* <a href={`${params.row.link}?httpResponseContentDisposition=attachment%3B%20filename%3D${params.row.fileName}`} download >
            <DownloadIcon />
          </a> */}
          <div
            onClick={() => handleLinkDownload(params.row.id)}
            style={{ cursor: 'pointer' }}
          >
            <DownloadIcon />
          </div>
          <RemoveRedEyeOutlinedIcon onClick={() => {
            setModal(true)
            setFilePath(params.row.link)
            setFileName(params.row.fileName)
          }
          } />
          {
            !disabled && hasDeletePermissionForProjectCoreDocument &&
            <DeleteOutlineOutlinedIcon className="" onClick={() => {
              setDocumentId(params.row.fileId)
              setIsOpenSweetAlert(true)
            }} />
          }

          {/* previous code  */}

          {/* New Icons as per figma design */}

        </div>
      ),
    },
  ];

  const handleLinkDownload = async (documentId) => {
    try {
      const result = await getDownloadableLink(documentId);
      if (result.statusCode === 200) {
        toast.success(result.data.message);
        window.open(result.data.data, '_blank');
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.error('Error downloading document:', error);
    }
  };

  const handleChangePage = async (event, newPage) => {
    setDocuments([])
    setPage(newPage);
  };

  const handleChangeRowsPerPage = async (event) => {
    setDocuments([])
    const perPage = parseInt(event.target.value);
    setRowsPerPage(perPage);
  };

  const handelDelete = async () => {
    setIsOpenSweetAlert(false)
    try {
      setIsLoading(true)
      const res = await deleteDocument(documentId)
      toast.success(res.data.message)
      // fetchDocumentList({ page: 0, perPage: rowsPerPage });
      if (page === 0) {
        setTriggerElement(+new Date())
      } else {
        setPage(0);
      }
      setDocumentId()
    } catch (err) {
      toast.error(err.message)
    }
    finally {
      setDocumentId()
    }
  }

  // useEffect(() => {
  //   fetchDocumentList({ page, perPage: rowsPerPage });
  // }, [page, rowsPerPage])

  useEffect(() => {
    fetchDocumentList({ page, perPage: rowsPerPage })
    if (!mounted) {
      setMounted((true))
    }
  }, [triggerElement])

  useEffect(() => {
    if (mounted) {
      if (page !== 0) {
        setPage(0)
        setTriggerElement(+new Date())
      } else {
        setTriggerElement(+new Date())
      }
    }
  }, [rowsPerPage, refresh])

  useEffect(() => {
    if (mounted) {
      setTriggerElement(+new Date())
    }
  }, [page])

  const fetchDocumentList = async () => {
    setIsLoading(true)
    try {
      let params = {
        page: page + 1,
        perPage: rowsPerPage,
        module: Modules.PROJECT,
        moduleId: project,
        projectId: project,
      };
      const res = (await documentList(params)).data.data;
      setPaginatedObject(res.meta)
      let level = ((page + 1) - 1) * rowsPerPage
      if (res.data.length > 0) {
        setDocuments(res.data.map((document, index) => ({
          id: ++level,
          fileName: document.name,
          uploadDate: dayjs(document.createdAt).format('DD.MM.YYYY'),
          uploadBy: document.uploader.name,
          link: getUrl(document.storageLink),
          fileId: document.id,
          user: document.uploader
        })));
        setTotalRows(res.meta.total);
      } else {
        setDocuments([]);
        setTotalRows(0);
      }
    } catch (error) {
      setIsLoading(false)
      console.log(error)
    } finally {
      setIsLoading(false);
    }
  }

  const handlePaginationModelChange = (data) => {
    setPage(data.page);

    if (rowsPerPage !== data.pageSize) {
      setRowsPerPage(data.pageSize);
    }
  };

  const getRowId = (row) => row.id;

  return (
    <div className="projectSubmission teamTable customTabCard">
      <Card
        className="viewProjectApproval"
        style={{ height: 500, width: "100%", border: "none" }}
      >
        <DataGrid
          rows={documents}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { pageSize: rowsPerPage },
            },
          }}
          pageSizeOptions={PerPage}
          disableRowSelectionOnClick
          onPaginationModelChange={handlePaginationModelChange}
          paginationMode="server"
          rowCount={totalRows}
          getRowId={getRowId}
          loading={isLoading}
          sortingMode="server"
          localeText={{
            noRowsLabel: t("No documents available for this startup."),
          }}
          hideFooter={true}
        />
        {documents.length > 0 && (
          <div className="ongoingProjPagination d-flex justify-content-end mt-3 newRoundedPagination">
            <PaginationComponent
              paginationObject={paginatedObject}
              page={page}
              handleChangePage={handleChangePage}
              rowsPerPage={rowsPerPage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </div>
        )}
      </Card>
      {isOpenSweetAlert && (
        <SweetAlert
          title={t("Are you sure want to delete this document") + "?"}
          warning
          showCancel
          confirmBtnText={t("OK")}
          cancelBtnText={t("Cancel")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            handelDelete();
          }}
          onCancel={() => {
            setIsOpenSweetAlert(false);
          }}
        ></SweetAlert>
      )}
      <FilePreviewModal
        modal={modal}
        setModal={setModal}
        filePath={filePath}
        fileName={fileName}
      />
    </div>
  );
}

export default withTranslation()(ProjectInfoTab)
